"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveSalesEmeRecord = exports.getSalesEmeRecordRoleList = exports.getSalesEmeRecordLeaderList = exports.exportSalesEmeRecordLeaderList = exports.auditSalesEmeRecord = void 0;
var _request = _interopRequireDefault(require("../../request"));
var getSalesEmeRecordRoleList = exports.getSalesEmeRecordRoleList = function getSalesEmeRecordRoleList(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/salesEmeRecord/role/list",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};
var getSalesEmeRecordLeaderList = exports.getSalesEmeRecordLeaderList = function getSalesEmeRecordLeaderList(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/salesEmeRecord/leader/list",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};
var saveSalesEmeRecord = exports.saveSalesEmeRecord = function saveSalesEmeRecord(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/salesEmeRecord/save",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};
var auditSalesEmeRecord = exports.auditSalesEmeRecord = function auditSalesEmeRecord(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/salesEmeRecord/audit",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};
var exportSalesEmeRecordLeaderList = exports.exportSalesEmeRecordLeaderList = function exportSalesEmeRecordLeaderList(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/salesEmeRecord/leader/list/export",
    method: 'post',
    data: data,
    cancelToken: cancelToken,
    responseType: 'blob'
  });
};